import {styled} from "@mui/material/styles";

export const FlexRowWrapper = styled("div")`
    display:flex;
    align-items: center;
    flex-wrap:wrap;
    gap:10px;
`
